import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';

import { AbstractRequestFormAdaptor } from '../../../../common/form/abstract-request-form.adaptor';

export interface ReferralLoginForm {
  email: string;
  phone: string;
  token: string;
  login_method: 'email' | 'phone';
}

export interface LoginMethodValidationError {
  code: 'INVALID_LOGIN_METHOD';
  message: string;
  alternative: 'email' | 'phone';
  details: string;
}

interface ReferralLoginResponse {}

@Injectable()
export class ReferralLoginAdaptor extends AbstractRequestFormAdaptor<ReferralLoginForm, ReferralLoginResponse> {
  name = 'referral-login';

  private http = inject(HttpClient);
  private navCtrl = inject(NavController);

  // Method to clear error state and allow retry
  clearError() {
    (this as any)._errors.next(null);
    (this as any)._state.next('idle');
  }

  onRequest({ token, login_method }: ReferralLoginForm): Observable<ReferralLoginResponse> {
    return this.http.post(`/referrals/${token}/accept`, null, { params: { login_method } });
  }

  override onSuccess({ login_method, email, phone }: ReferralLoginForm) {
    this.navCtrl.navigateRoot(['magic-link', 'register', login_method], { queryParams: { email, phone } });
  }

  override onError(formData: ReferralLoginForm, errorRes: unknown, formGroup: any) {
    // Check if this is a login method validation error
    if (errorRes instanceof HttpErrorResponse && errorRes.status === 422) {
      const errorData = errorRes.error?.errors;
      if (errorData?.code === 'INVALID_LOGIN_METHOD') {
        // Don't navigate away - let the component handle showing the error
        // The error will be automatically emitted via the errors$ observable

        return;
      }
    }

    // For other errors, call the parent implementation
    super.onError?.(formData, errorRes, formGroup);
  }
}
